/**
 * @function createStableImageBitmap
 * Safari and Edge polyfill for createImageBitmap which ended up being more stable than the real
 * implementation of createImageBitmap on Chrome.
 *
 * Context: using createImageBitmap on each frame used in the Cyclon video scrubbing was making
 * the Chrome tab crash on Android. Using this polyfill on Chrome as well solved the issue.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/createImageBitmap
 */
export function createStableImageBitmap(blob) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    const src = URL.createObjectURL(blob)
    img.src = src
    img.onload = () => {
      URL.revokeObjectURL(src)
      resolve(img)
    }
    img.onerror = reject
  })
}

/**
 * @function optimizeContentfulAssetUrls
 * Basic optimization of Contentful asset urls using their parameters. If you want to use the url
 * in an <img> tag, you should probably use ImageContentful.vue instead of this function.
 */
export function optimizeContentfulAssetUrls(
  assetUrls,
  { width, quality = 71, format = 'jpg', devicePixelRatio = 1 }
) {
  if (!width) throw new Error('[optimizeContentfulAssetUrls] - "width" is required')

  const urlParams = [
    `w=${width * (1 + (devicePixelRatio - 1) / 2)}`,
    `q=${quality}`,
    `fm=${format}`,
  ]
  return assetUrls.map(url => {
    // Add protocol (i.e. "https:") to make it an absolute url an avoid errors within Web workers
    const protocol = /^\/\//.test(url) ? self.location.protocol : ''
    return `${protocol}${url}?${urlParams.join('&')}`
  })
}
